var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 5H3.83l3.58-3.59L6 0 0 6l6 6 1.41-1.41L3.83 7H18z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE4IDEyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjEsMTFINi44M2wzLjU4LTMuNTlMOSw2LDMsMTJsNiw2LDEuNDEtMS40MUw2LjgzLDEzSDIxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTYpIi8+PC9zdmc+";
export { SvgBackArrow as ReactComponent };